import { actionize, apiAction, apiFetch } from 'utils';
import DuckEntity from './DuckEntity';

const duck = new DuckEntity('billingCategoryGroups');

let types = {
  MOVE_BEGIN: null,
  MOVE_ERROR: null,
  MOVE_SUCCESS: null
};
types = actionize(types, (action) => `schooladmin/billing_category_groups/${action}`);

/**
 * Moves a category to a different group
 *
 * @param id - the id of the category to move
 * @param targetGroupId - the id of the parent group to target
 * @param categoryType - the category type
 */
const moveCategory = (id, targetGroupId, categoryType) => apiAction(
  types.MOVE_BEGIN, types.MOVE_SUCCESS, types.MOVE_ERROR,
  (state) => (
    apiFetch.post(state, `${duck.config.entityApiPath(id)}/move`, {
      target_group_id: targetGroupId,
      category_type: categoryType
    })
  ),
  {
    entityName: duck.config.name,
    id
  },
  { billing_category_group: duck.config.schema }
);

export default duck.reducer;

export const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    moveCategory
  }
};
